import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import DashboardTasksDefaultPage from './Pages/DashboardTasksDefaultPage';
import DashboardTasksWizardPage from './Pages/DashboardTasksWizardPage';

const DashboardTasksRouter = () => {
    let { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={`${path}/wizard`}>
                <DashboardTasksWizardPage />
            </Route>
            <Route path={`${path}/:cobrandDashboardTaskId/wizard`}>
                <DashboardTasksWizardPage />
            </Route>
            <Route default>
                <DashboardTasksDefaultPage />
            </Route>
        </Switch>
    );
};

export default DashboardTasksRouter;
